var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('table',[_c('col',{attrs:{"width":"150"}}),_c('tr',[_c('td',[_vm._v("Huidig saldo")]),_c('td',[_vm._v(_vm._s(_vm.computedBalance))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }